import 'css-chunksrc/client/scenes/constraintEdition/endEndForm/styles.scss';export default {
  "form": "_form_jn2ce_1"
};